/* eslint-disable */
export default {
  saveLog: '저장',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
